module.exports = __webpack_public_path__ + "img/sld_icog_panel.be4cf1ee.svg";